import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const ERROR_INITIAL: any = {
  error: false,
  message: "",
  isLoading: false,
  success: false,
};

const errorSlice = createSlice({
  name: "error",
  initialState: {
    ...ERROR_INITIAL,
  },
  reducers: {
    ERROR_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Number | Object;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { ERROR_UPDATE } = errorSlice.actions;

export { errorSlice, ERROR_INITIAL, ERROR_UPDATE };
